import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20Korean%20webtoon%20style%20illustration%20with%20soft%20dreamy%20atmosphere%2C%20pastel%20color%20palette%20of%20warm%20peach%20and%20soft%20cream%20tones%2C%20abstract%20flowing%20shapes%20reminiscent%20of%20comic%20panels%2C%20gentle%20gradients%2C%20minimalist%20composition%2C%20airy%20and%20light%2C%20no%20text%2C%20subtle%20texture%2C%20modern%20art%20direction&width=1600&height=900&seq=hero-bg-main-01&orientation=landscape"
        alt="韩国漫画网 - 免费韩漫大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6">
        <h1 className="font-heading text-3xl md:text-6xl lg:text-7xl font-bold text-white text-center leading-tight max-w-4xl">
          免费韩漫大全
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 text-center max-w-2xl leading-relaxed">
          海量好看的韩国漫画每日更新，支持高清韩漫在线观看<br className="hidden sm:block" />
          随时随地畅享最优质的漫画阅读体验
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/romance"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base cursor-pointer hover:bg-primary-600 transition-colors"
          >
            立即阅读
          </Link>
          <Link
            to="/category/fantasy"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/50 text-white font-medium text-sm md:text-base cursor-pointer hover:bg-white/10 transition-colors"
          >
            探索分类
          </Link>
        </div>
      </div>
    </section>
  );
}